package features.booking

import androidx.compose.ui.graphics.Color

/**
 * Paleta de colores centralizada de SmartVan.
 * Evita repetir hex hardcodeados en cada archivo.
 */
object SmartVanColors {
    // Primarios
    val AzulOscuro = Color(0xFF00205B)
    val CyanAccent = Color(0xFF00ACC1)

    // Fondos
    val FondoClaro = Color(0xFFF5F7FA)
    val FondoPanel = Color(0xFFF8F9FA)

    // Estados
    val Verde = Color(0xFF4CAF50)
    val Rojo = Color(0xFFFF5252)
    val Naranja = Color(0xFFFF9800)
    val Amarillo = Color(0xFFFFC107)

    // Texto
    val TextoPrimario = Color(0xFF333333)
    val TextoSecundario = Color(0xFF666666)

    // Asientos
    val AsientoDisponible = Color(0xFFE8F5E9)
    val AsientoOcupado = Color(0xFFFF5252)
    val AsientoSeleccionado = Color(0xFF00ACC1)

    // Admin
    val AdminHeader = Color(0xFF00205B)
    val AdminAccent = Color(0xFF00ACC1)

    // Bordes y separadores
    val Borde = Color(0xFFE0E0E0)
    val FondoGris = Color(0xFFEEEEEE)
    val FondoGrisClaro = Color(0xFFF5F5F5)

    // Fondos tintados
    val FondoCyan = Color(0xFFE0F7FA)
    val FondoRojo = Color(0xFFFFEBEE)
    val FondoNaranja = Color(0xFFFFF3E0)
    val FondoAmarillo = Color(0xFFFFF8E1)

    // Colores secundarios
    val Azul = Color(0xFF1E88E5)
    val NaranjaDark = Color(0xFFFF8F00)
    val NaranjaDeep = Color(0xFFE65100)
    val Purpura = Color(0xFF7C4DFF)
    val PurpuraDark = Color(0xFF6A1B9A)
    val RojoFuerte = Color(0xFFE53935)
    val VerdeOscuro = Color(0xFF2E7D32)
}
